'use client';

import { forwardRef, useContext, useId } from 'react';

import { css, cx } from '@/styled-system/css';

import { useIsomorphicLayoutEffect } from '../../hooks/use-isomorphic-layout-effect';
import { DropdownRootContext } from './context/dropdown-root.context';
import { dropdownHeaderStyles } from './styles/dropdown-header.styles';
import type { DropdownHeaderPropsInterface } from './types/dropdown-header.types';

/**
 * @since 10.0.0
 */
export const DropdownHeader = forwardRef<HTMLDivElement, DropdownHeaderPropsInterface>(
  (props: DropdownHeaderPropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;
    const { dropdown } = useContext(DropdownRootContext);
    const id = useId();
    const styles = css(dropdownHeaderStyles, cssProp);

    useIsomorphicLayoutEffect(() => {
      dropdown.setLabelId(id);
      return () => dropdown.setLabelId(undefined);
    }, [id, dropdown.setLabelId]);

    return (
      <div
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Dropdown.Header"
        id={id}
        className={cx('c11n', 'c11n_dropdown__header', styles, className)}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

DropdownHeader.displayName = 'Dropdown.Header';
